import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ColDef,IServerSideGetRowsParams } from 'ag-grid-community';
 
import { Router } from '@angular/router';
import { AssetService } from 'src/app/_services/asset.service';
import { Subscription } from 'rxjs';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
var dateFormateChange: any;

@Component({
    selector: 'app-custella-assets',
    templateUrl: './custella-assets.component.html',
    styleUrls: ['./custella-assets.component.scss'],
    standalone: false
})
export class CustellaAssetsComponent implements OnInit {

  @Output() assetSelector = new EventEmitter();
  @Output() closeAssetView = new EventEmitter();
  @Output() closeTable = new EventEmitter();
  @Input() assetId: any;
  @Input() serviceZoneName: any;
  @Input() lookupFilter: any ='';
  @Input() searchValue: any
 @Input() siteId:any =''
 @Input() customerId: any = null
 @Input() eligibleParentAssets:boolean = false
 @Input() eligibleChildAssets:boolean = false
 @Input() assetsIgnoreId:any = null
 @Input() projectId: any = null
   assets: any;
   currentRecordNumber: any;
   noCustomers: boolean = false;
   noCustomersIcon: boolean = false;
   filter: any = {assetStatuses : '',assetTypes : '',fromDate: '', toDate : ''}
   dateFormat: any;
   assetitemsHandlerSubscription: Subscription
   filterData: boolean = true
  translate: any;
  constructor(
    private router : Router,
    private assetService:AssetService,
    private languageTranslateService: LanguageTranslateService
  ) { 
    this.languageTranslateService.menuSrc$.subscribe(data => {
      if(Object.keys(data).length != 0){ this.translate = data}
    })
    this.assetitemsHandlerSubscription = assetService.assetitemsHandler.subscribe((response: any) => {
      console.log(response, 'response printing in app-custella-assets')
      this.selectAssetRecord( response);
  });
  }

  ngOnInit() {
    console.log(this.lookupFilter,"========")
    this.dateFormat = localStorage.getItem('date_format')
   
  }
 

  selectAssetRecord(val:any){
    //check serialNo exist. If it doesn't, call the single asset api and take the value
    if (!val.serialNo){
      this.assetService.getAssetsById(val.id).subscribe((res: any) =>{
        val = res
        
        if(res){
          val['serialNo'] = res.serialNo;
          this.assetSelector.emit(val);
        }
      })
    }
    else{
      this.assetSelector.emit(val);
    }
  }

  closeAsset(){
    this.closeAssetView.emit(false)
    this.closeTable.emit(false)
  }
  ngOnDestroy() {
    
    if (this.assetitemsHandlerSubscription) {
      this.assetitemsHandlerSubscription.unsubscribe();
  }


}
  
}